import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WalkingNotice } from 'components/OnlineBooking/Walking/Address/WalkingNotice';
import classes from 'components/OnlineBooking/Walking/Address/WalkingNotice.module.scss';
import React from 'react';

interface AddressPromptProps {
    onAddAddress: () => void;
}

export const AddressPrompt: React.FC<AddressPromptProps> = ({ onAddAddress }) => {
    return (
        <WalkingNotice>
            <p className={classes.text}>
                This business offers In-Home services, but you need to add your address to view
                them.
            </p>
            <button type="button" className={classes.link} onClick={onAddAddress}>
                <FontAwesomeIcon icon={faPlus} />
                Add Address
            </button>
        </WalkingNotice>
    );
};
